<script>
	import { afterUpdate } from "svelte";
	import { cubicOut } from "svelte/easing";

	import Manufacturers from "../visualizations/Manufacturers.svelte";
	import Shootings from "../visualizations/Shootings.svelte";
	import ProducedWeapons from "../visualizations/ProducedWeapons.svelte";

	export let component;
	export let scaledSectionProgress;
	export let color;

	let background;

	afterUpdate(() => {
		if (background) {
			const elementsDom = background.children[0].children;
			if (elementsDom.length > 1) {
				// TF BUG: If you switch components, there's a bug. It adds multiple components to the div even though it should only add one. I have no idea why 🤷‍♀️
				// TF HACK: remove all DOM elements that do not have the component id
				Array.from(elementsDom).forEach((elem) => {
					if (component !== elem.id) elem.remove();
				});
			}
		}
	});

	const transition = { duration: 3000, easing: cubicOut };
</script>

<div class="background" bind:this={background} style:background-color={color || ""}>
	<div>
		{#if component === "shootings"}
			<div class="vis-container" id={component}>
				<Shootings
					{...$$props}
					id={component}
					progress={scaledSectionProgress}
					transitionIn={transition}
					transitionOut={transition}
				/>
			</div>
		{:else if component === "produced_weapons"}
			<div class="vis-container" id={component}>
				<ProducedWeapons
					{...$$props}
					id={component}
					progress={scaledSectionProgress}
					transitionIn={transition}
					transitionOut={transition}
				/>
			</div>
		{:else if component === "manufacturers"}
			<div class="vis-container" id={component}>
				<Manufacturers
					{...$$props}
					id={component}
					progress={scaledSectionProgress}
					transitionIn={transition}
					transitionOut={transition}
				/>
			</div>
		{/if}
	</div>
</div>

<style lang="scss">
	.square {
		width: 30px;
		height: 30px;
		background-color: blue;
	}

	$mobile-padding: 20px;
	$desktop-padding: 50px;

	.background {
		height: 100%;
		will-change: background-color;
		background-color: $black;
		transition: background-color 0.5s ease-in-out;
		font-family: $ff-sans;

		div {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 100%;
			// width: calc(100% - #{2*$mobile-padding});
			// height: calc(100% - #{2*$mobile-padding});
			// gap: $mobile-padding*2;
			// padding: $mobile-padding;

			@media (min-width: #{$breakpoint-mobile}) {
				// width: calc(100% - #{2*$desktop-padding});
				// height: calc(100% - #{2*$desktop-padding});
				// gap: $desktop-padding*2;
				// padding: $desktop-padding;
				flex-direction: row;
			}
		}
	}

	.vis-container {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
</style>
